import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const CardWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;
